var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightPnpmSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_light_pnpm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30,10.75H21.251V2H30Z",
    style: {
      fill: "#f9ad00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.374,10.75h-8.75V2h8.75Z",
    style: {
      fill: "#f9ad00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.749,10.75H2V2h8.749Z",
    style: {
      fill: "#f9ad00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,20.375H21.251v-8.75H30Z",
    style: {
      fill: "#f9ad00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.374,20.375h-8.75v-8.75h8.75Z",
    style: {
      fill: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.374,30h-8.75V21.25h8.75Z",
    style: {
      fill: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H21.251V21.25H30Z",
    style: {
      fill: "#4e4e4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.749,30H2V21.25h8.749Z",
    style: {
      fill: "#4e4e4e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPnpmSvgrepoCom);
export default __webpack_public_path__ + "static/media/light-pnpm-svgrepo-com.e17132fd65fc9d11b4876da09bcf1755.svg";
export { ForwardRef as ReactComponent };